module.exports = __webpack_public_path__ + "media/src/javascripts/ienavi-frontend/components/budget-simulator/assets/mvpc-a6a3083ec6c8611a09208ded3484ff36.jpg";